<template>
  <section class="form-list">
    <el-form
        ref="form"
        class="form form-extra-large"
        label-position="left"
        label-width="160px"
    >
      <el-form-item label="添加时间">{{ postData.add_time | timeToYmdHis }}</el-form-item>
      <el-form-item label="日志 ID">{{ id }}</el-form-item>
      <el-form-item label="所属学员">
        <v-avatar-nickname
          :value="postData.selfie"
          :nickname="postData.student_name"
          :is-center="true"
          :nickname-overflow="true"
          :link-page-name="RouteConfig.studentDetail.name"
          :link-page-id="postData.student_id"
          :avatar-size="50"
        />
      </el-form-item>
      <el-form-item label="添加时间">{{ postData.add_time | timeToYmdHis }}</el-form-item>
      <el-form-item label="错误类型">
        <el-tag v-for="apiErrorType in findApiErrorType(postData.error_type)" :type="apiErrorType.tagType" :key="`apiErrorType${apiErrorType.value}`">
          {{ apiErrorType.name }}
        </el-tag>
      </el-form-item>
      <el-form-item label="状态码">{{ postData.status_code }}</el-form-item>
      <el-form-item label="错误消息">{{ postData.error_message }}</el-form-item>
      <el-form-item label="错误内容">{{ postData.response_body }}</el-form-item>
      <el-form-item label="订单号">{{ postData.out_trade_no }}</el-form-item>
      <el-form-item label="请求类型">
        <el-tag v-for="requestType in findRequestType(postData.request_type)" :type="requestType.tagType" :key="`requestType${requestType.value}`">
          {{ requestType.name }}
        </el-tag>
      </el-form-item>
      <el-form-item>
        <el-button @click="RouteConfig.errorLogList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { getWeChatOrderDetails } from '@/api/error-log';
import { findApiErrorType } from '@/enums/apiErrorTypes';
import { findRequestType } from '@/enums/weChatPayRequestTypes';

export default {
  name: RouteConfig.errorLogWeChatOrderDetail.name,
  data: () => ({
    RouteConfig,
    postData: {},
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    findApiErrorType,
    findRequestType,
    async show() {
      const { isError, data } = await getWeChatOrderDetails(this.id);
      if (isError || !data) return;
      this.postData = data;
    },
  },
};
</script>
